module.exports = __webpack_public_path__ + "static/zasuvka-c774ce92e15c98a825ff7594e7f9ddf9.png";